import React, { useState } from 'react';
import { Award, CircleAlert, Coins, FileText, Pencil, Trash2, Users, BarChart3, BookOpen } from 'lucide-react';
import ListItemCard from '../../../components/common/ListItemCard';
import { ReportType } from '../../reports/types/report.types';

interface ClassItem {
  id: string;
  title: string;
  category: string;
  students: number;
  avg: string;
  gender: string;
}

interface ClassCatalogProps {
  items: ClassItem[];
  selectedClassId: string | null;
  onSelect: (classId: string) => void;
  onEdit: (classId: string) => void;
  onRemove: (classId: string) => void;
  onOpenReport: (classId: string, reportType: ReportType) => void;
}

const simplifyAgeGroupLabel = (value: string) => {
  if (value.includes(':')) {
    return value.split(':')[0].trim();
  }

  if (value.includes('(')) {
    return value.split('(')[0].trim();
  }

  return value.trim();
};

const ClassCatalog: React.FC<ClassCatalogProps> = ({ items, selectedClassId, onSelect, onEdit, onRemove, onOpenReport }) => {
  const [openMenuId, setOpenMenuId] = useState<string | null>(null);

  return (
    <section className="space-y-3">
      <div className="space-y-4">
        {items.map((item) => (
          <ListItemCard
            key={item.id}
            title={simplifyAgeGroupLabel(item.category)}
            subtitle={item.title}
            isActive={selectedClassId === item.id}
            onClick={() => onSelect(item.id)}
            leadingIcon={BookOpen}
            menuOpen={openMenuId === item.id}
            onToggleMenu={() => setOpenMenuId(openMenuId === item.id ? null : item.id)}
            actions={[
              {
                label: 'Relatório da turma',
                icon: FileText,
                tone: 'bg-emerald-50 text-emerald-700',
                onClick: () => {
                  setOpenMenuId(null);
                  onOpenReport(item.id, 'by-class');
                },
              },
              {
                label: 'Alunos faltosos',
                icon: CircleAlert,
                tone: 'bg-rose-50 text-rose-700',
                onClick: () => {
                  setOpenMenuId(null);
                  onOpenReport(item.id, 'absentees');
                },
              },
              {
                label: 'Certificado 100%',
                icon: Award,
                tone: 'bg-amber-50 text-amber-700',
                onClick: () => {
                  setOpenMenuId(null);
                  onOpenReport(item.id, 'honor-certificate');
                },
              },
              {
                label: 'Ofertas do período',
                icon: Coins,
                tone: 'bg-orange-50 text-orange-700',
                onClick: () => {
                  setOpenMenuId(null);
                  onOpenReport(item.id, 'offerings-period');
                },
              },
              {
                label: 'Editar turma',
                icon: Pencil,
                tone: 'text-sky-600 bg-sky-50',
                onClick: () => {
                  setOpenMenuId(null);
                  onEdit(item.id);
                },
              },
              {
                label: 'Remover',
                icon: Trash2,
                tone: 'text-rose-600 bg-rose-50',
                onClick: () => {
                  setOpenMenuId(null);
                  onRemove(item.id);
                },
              },
            ]}
            metricLeft={{
              icon: Users,
              label: `${item.students} alunos`,
              tone: 'bg-sky-50 text-sky-600',
            }}
            metricRight={{
              icon: BarChart3,
              label: `${item.avg} de presença`,
              tone: 'bg-emerald-50 text-emerald-600',
            }}
          />
        ))}
      </div>
    </section>
  );
};

export default ClassCatalog;
